/**
 * Application Permissions
 * 
 * Centralized permission constants for type safety and maintainability.
 * These match the backend permission strings.
 */

export const PERMISSIONS = {
  VIEW_ALL_USERS: 'view_all_users',
  VIEW_ACCOUNT_INFORMATION: 'view_account_information',
  ADD_USERS: 'add_users',
  DELETE_USERS: 'delete_users',
  CHANGE_USER_PASSWORDS: 'change_user_passwords',
  CREATE_ACCOUNT: 'create_account',
  VIEW_ACCOUNTS: 'view_accounts',
  EDIT_ACCOUNT: 'edite_account',
  IMPERSONATE_USER: 'impersonate_user',
  VIEW_ALL_CREDENTIALS: 'view_all_credentials',
  ADD_CREDENTIAL: 'add_credential',
  ROTATE_CREDENTIAL: 'rotate_credential',
  REVOKE_CREDENTIAL: 'revoke_credential',
} as const;

/**
 * Type for permission values
 */
export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];

/**
 * Helper to check if a string is a valid permission
 */
export function isValidPermission(value: string): value is Permission {
  return Object.values(PERMISSIONS).includes(value as Permission);
}

